module.exports = __webpack_public_path__ + "static/media/lucide_hospital.f27dba99.svg";